'use strict';

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./content/customerServicesSidebar'));
    processInclude(require('./contactUs/contactUs'));
});
